import React from 'react';
import { Flex, Image, useColorModeValue } from '@chakra-ui/react';
import { HSeparator } from 'components/separator/Separator';
export function SidebarBrand() {
 
  let logoColor = useColorModeValue('navy.700', 'white');

  return (
    <Flex align="center" direction="column">
     

      <Image
        src="/logo.png"
        alt="Zudpi Land Survey Logo"
        mx="auto"
        maxH="120px"
        padding="10px"
      />

      <HSeparator mb="20px" />
    </Flex>
  );
}

export default SidebarBrand;